import { render, staticRenderFns } from "./SoftphoneWidget.vue?vue&type=template&id=77f3b5ce&scoped=true"
import script from "./SoftphoneWidget.vue?vue&type=script&lang=js"
export * from "./SoftphoneWidget.vue?vue&type=script&lang=js"
import style0 from "./SoftphoneWidget.vue?vue&type=style&index=0&id=77f3b5ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f3b5ce",
  null
  
)

export default component.exports